import { compose } from 'redux';
import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';

import NewsList from '../components/NewsList';

import { newsRequest } from '../services/actions';
import { selectNews, selectListPending } from '../services/selectors';

export default compose(
    connect(
        state => ({
            news: selectNews(state, {}),
            showLoader: selectListPending(state, {}),
        }),
        dispatch => ({
            read: () => {
                dispatch(newsRequest());
            },
        }),
    ),
    routeDependencies(),
    loadable,
)(NewsList);
